<template>
    <div>
        <el-table :data="data" style="width: 100%" :cell-style="cellStyle" :header-cell-style="rowClass">
            <el-table-column prop="name" label="模版名称" > </el-table-column>
            <el-table-column prop="topicNum" label="题目数量" width="80"> </el-table-column>
            <el-table-column prop="score" label="总分" width="80"> </el-table-column>
            <el-table-column prop="passScore" label="及格分" width="80"> </el-table-column>
            <el-table-column prop="createTime" label="创建时间" > </el-table-column>
            
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button @click="handleSee(scope.row)" type="text" size="small">预览</el-button>
                    <el-button type="text" size="small" @click="handTempEdit(scope.row)">编辑</el-button>
                    <el-button type="text" size="small" @click="handTempRomve(scope.row)" >删除</el-button>
                </template>
            </el-table-column>
        </el-table>
  </div>
</template>
<script>
export default {
    props:{
        data: {
            type: Array,
            default: () => {
                return []
            },
        },
    },
    data() {
        return {
            jsonList:{},
            courseValue:'',
            expValue:'',
        }
    },
    methods: {
        handleSee(val){
            this.$emit('handleSee',val)
        },
        handTempEdit(val){
            this.$emit('handTempEdit',val)
        },
        handTempRomve(val){
            this.$emit('handTempRomve',val)
        },
        cellStyle(){
            return "text-align:center"
        },
        rowClass(){
            return "text-align:center"
        }
    },
}
</script>
